
// Country utility functions

import { countries } from "@/data/regions";

/**
 * Get full country name by value (code)
 */
export const getCountryName = (countryValue: string): string => {
  // If it's already a country name, return it
  if (["Germany", "Austria", "Switzerland", "Deutschland", "Österreich", "Schweiz"].includes(countryValue)) {
    return countryValue;
  }
  
  // Handle new country codes
  if (countryValue === 'de' || countryValue === 'germany') return 'Germany';
  if (countryValue === 'at' || countryValue === 'austria') return 'Austria';
  if (countryValue === 'ch' || countryValue === 'switzerland') return 'Switzerland';
  
  // Look up in country data
  const country = countries.find(c => c.value === countryValue);
  if (country) {
    return country.name.en; // Use English names as they match our database
  }
  
  // Default fallback
  console.warn(`Unknown country value: ${countryValue}, defaulting to Germany`);
  return 'Germany';
};

/**
 * Get country by value (code)
 */
export const getCountryByValue = (countryValue: string): any => {
  // First try exact match
  const exactMatch = countries.find(country => country.value === countryValue);
  if (exactMatch) return exactMatch;
  
  // Try legacy values
  if (countryValue === 'germany') return countries.find(country => country.value === 'de');
  if (countryValue === 'austria') return countries.find(country => country.value === 'at');
  if (countryValue === 'switzerland') return countries.find(country => country.value === 'ch');
  
  // Try normalized values
  const normalized = normalizeCountryValue(countryValue);
  return countries.find(country => country.value === normalized);
};

/**
 * Normalize country value to standard format
 */
export const normalizeCountryValue = (countryValue: string): string => {
  // Handle legacy country values
  if (countryValue === 'germany') return 'de';
  if (countryValue === 'austria') return 'at';
  if (countryValue === 'switzerland') return 'ch';
  
  // Return as is if it's already in the correct format
  if (['de', 'at', 'ch'].includes(countryValue)) {
    return countryValue;
  }
  
  // Default fallback
  return 'de';
};
